'use client';

import { Button } from '@zillow/constellation-10';
import { logError } from '@zg-rentals/log-error';
import { Bell } from 'lucide-react';
import { useEffect, useRef } from 'react';

import { LucideIcon } from '@/src/components/LucideIcon';
import { useOptionalSrpSaveSearch } from './SrpSaveSearchProvider';

const MISSING_SAVE_SEARCH_CONTEXT = {
  isSaved: false,
  isDisabled: true,
  label: 'Save search',
  handleToggle: () => undefined,
};

export function SrpSaveSearchButton() {
  const saveSearch = useOptionalSrpSaveSearch();
  const hasLoggedMissingContext = useRef(false);

  useEffect(() => {
    if (!saveSearch && !hasLoggedMissingContext.current) {
      hasLoggedMissingContext.current = true;
      logError({
        error: new Error('SrpSaveSearchButton rendered without SrpSaveSearchProvider'),
        errorType: 'MissingSrpSaveSearchProvider',
      });
    }
  }, [saveSearch]);

  const { isSaved, isDisabled, label, handleToggle } = saveSearch ?? MISSING_SAVE_SEARCH_CONTEXT;
  const handleClick = () => {
    if (!isDisabled) {
      handleToggle();
    }
  };

  const icon = <LucideIcon icon={Bell} size="sm" fill={isSaved ? 'currentColor' : 'none'} />;

  return (
    <Button
      data-testid="button-save-search"
      type="button"
      tone="brand"
      emphasis="filled"
      size="sm"
      icon={icon}
      iconPosition="start"
      css={{
        whiteSpace: 'nowrap',
      }}
      onClick={handleClick}
      disabled={isDisabled}
      aria-pressed={isSaved}
    >
      {label}
    </Button>
  );
}
